// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as $$Promise from "@ryyppy/rescript-promise/src/Promise.bs.js";
import * as Ethers$SensumPwa from "../blockchain/eth/ethers/Ethers.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Pages_Sensations$SensumPwa from "../pages/sensations/Pages_Sensations.bs.js";
import * as Pages_NewSensation$SensumPwa from "../pages/newSensation/Pages_NewSensation.bs.js";
import * as Pages_Configuration$SensumPwa from "../pages/configuration/Pages_Configuration.bs.js";
import * as State_Configuration$SensumPwa from "../state/configuration/State_Configuration.bs.js";

function Router(Props) {
  var match = State_Configuration$SensumPwa.useConfig(undefined);
  var config = match[0];
  React.useEffect((function () {
          State_Configuration$SensumPwa.syncNotificationConfig(config);
          var provider = Ethers$SensumPwa.getProvider(config.networkUrl);
          $$Promise.$$catch(Ethers$SensumPwa.getNetwork(provider).then(function (status) {
                    console.log("getNetwork::chainId", status.chainId);
                    return Promise.resolve(undefined);
                  }), (function (err) {
                  console.log("getNetwork::error", err);
                  return Promise.resolve(undefined);
                }));
          $$Promise.$$catch(Ethers$SensumPwa.getBlockNumber(provider).then(function (blockNumber) {
                    console.log("getBlockNumber::response", blockNumber);
                    return Promise.resolve(undefined);
                  }), (function (err) {
                  console.log("getBlockNumber::error", err);
                  return Promise.resolve(undefined);
                }));
        }), [config]);
  var routerUrl = RescriptReactRouter.useUrl(undefined, undefined);
  var match$1 = routerUrl.hash;
  switch (match$1) {
    case "config" :
        return React.createElement(Pages_Configuration$SensumPwa.make, {
                    config: config,
                    saveConfig: match[1]
                  });
    case "graveyard" :
        return React.createElement(Pages_Sensations$SensumPwa.make, {
                    config: config
                  });
    case "sanctuary" :
        return React.createElement(Pages_NewSensation$SensumPwa.make, {
                    config: config
                  });
    default:
      return React.createElement(Pages_Sensations$SensumPwa.make, {
                  config: config
                });
  }
}

var make = Router;

export {
  make ,
}
/* react Not a pure module */
